export const provinces = {
  phitsanulok: { name: "พิษณุโลก", center: [16.8, 100.2] },
  sukhothai: { name: "สุโขทัย", center: [17.0, 99.8] },
  tak: { name: "ตาก", center: [16.8, 98.9] },
  uttaradit: { name: "อุตรดิตถ์", center: [17.6, 100.1] },
  phetchabun: { name: "เพชรบูรณ์", center: [16.4, 101.2] },
};
